import axios from 'axios'
import { useNotificationsStore } from '@/stores/notifications'

/**
 * Авто-погашение уведомлений по сущности при заходе на её страницу.
 * Помечает прочитанными все уведомления текущего пользователя по сущности
 * и уменьшает счётчик непрочитанных в store.
 */
export function useNotificationAutoRead() {
  async function markEntityRead(entityType, entityId) {
    if (!entityType || !entityId) return
    try {
      const response = await axios.post('/api/notifications/mark-as-read-by-entity', {
        entity_type: entityType,
        entity_id: entityId,
      })
      const count = response.data?.count || 0
      if (count > 0) {
        const store = useNotificationsStore()
        store.unreadCount = Math.max(0, store.unreadCount - count)
      }
    } catch (error) {
      console.error('Ошибка авто-погашения уведомлений:', error)
    }
  }

  return { markEntityRead }
}
